import { render, staticRenderFns } from "./NovaTriagem.vue?vue&type=template&id=bf56381e"
import script from "./NovaTriagem.vue?vue&type=script&lang=js"
export * from "./NovaTriagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports